import React from 'react'
import { Hero, NavBar } from '../components'

const Home = () => (
  <div id="app" className="d-flex flex-column h-100">
    <NavBar />
    <div className="container">
      <div className="m-5">
        <h3>Links to test user email verification</h3>
        <div className="d-flex flex-column">
          <a href="http://localhost:9000/user-email-verification?success=true">
            User email verification success
          </a>
          <a href="http://localhost:9000/user-email-verification?success=false&message=Access%20expired.">
            User email verification link expired
          </a>
          <a href="http://localhost:9000/user-email-verification?success=false&message=This%20account%20is%20already%20verified.">
            User email verification link aleady verified
          </a>
          <a href="http://localhost:9000/user-email-verification?success=false&message=This%20URL%20can%20be%20used%20only%20once">
            User email verification link can be used only once
          </a>
        </div>
      </div>
    </div>
    <Hero />
  </div>
)

export default Home
